import { useMemo } from 'react'

import { useConnect } from 'redux-bundler-hook'

import { allowed, pickAllowedProps } from '~/src/Flags'
import { TIER_ALLOWED_ANNOTATION_TYPES } from '~/src/Flags/Tier/constants'
import createLogger from '~/src/Lib/Logging'

import { annotationTypes } from '../constants'

const logger = createLogger('Annotations/useAllowedAnnotationTypes')

/**
 * Returns set of annotation types filtered by facility tier and user permissions
 * @returns {Set<string>} Set of allowed annotation types (e.g. {'note', 'lightSchedule', 'targetRange', 'notification'} for GO tier)
 */
export const useAllowedAnnotationTypes = () => {
  const { config, myFlags, myPermissions } = useConnect('selectConfig', 'selectMyFlags', 'selectMyPermissions')
  const {
    [config.TIER]: tierAllowed = TIER_ALLOWED_ANNOTATION_TYPES.DEFAULT
  } = TIER_ALLOWED_ANNOTATION_TYPES

  const finalAllowed = useMemo(
    () => new Set(annotationTypes.filter(conf => {
      const { type } = conf
      if (!tierAllowed.has(type)) {
        logger.debug(type, 'not allowed by tier', config.TIER)
        return false
      }
      const allowedProps = { ...pickAllowedProps(conf), config, myFlags, myPermissions }

      const [isAllowed] = allowed(allowedProps)
      if (!isAllowed) {
        logger.debug(type, 'not allowed for user', allowedProps)
        return false
      }
      return true
    }).map(conf => conf.type)),
    [config, myFlags, myPermissions, tierAllowed]
  )
  logger.debug('finalAllowed', finalAllowed)
  return finalAllowed
}
